import React from "react";
import SectionHeading from "../SectionHeading";
import { Reveal } from "../Reveal";
import ContactForm from "../ContactForm";
import ContactInfo from "../ContactInfo";
import MapEmbed from "../MapEmbed";

export const ContactCTA = () => {
  return (
    <section id="contact" data-testid="home-contact-section" className="relative py-24 md:py-32 bg-navy">
      <div className="container-x">
        <SectionHeading
          overline="Let's Talk"
          title="Let's build something reliable together"
          subtitle="Tell us about your project or challenge. We'll get back within one business day with a clear next step."
        />

        <div className="mt-14 grid grid-cols-1 lg:grid-cols-12 gap-6">
          <Reveal className="lg:col-span-7 glass rounded-3xl p-8 md:p-10">
            <ContactForm />
          </Reveal>
          <Reveal delay={0.1} className="lg:col-span-5">
            <ContactInfo />
          </Reveal>
        </div>

        <Reveal delay={0.1} className="mt-6">
          <MapEmbed height="360px" />
        </Reveal>
      </div>
    </section>
  );
};

export default ContactCTA;
